module.exports = __webpack_public_path__ + "static/media/daewoo-go-drive.9fa3a20c.jpg";